import { httpClient } from './httpClient';

export const fetchPlanslist = async () => {
  const response = await httpClient.get('/plans/list');
  return response.data;
};

export const fetchPlanscreate = async (payload) => {
  const response = await httpClient.post('/plans/create', payload);
  return response.data;
};

export const getCompanyPlans = async (companyId) => {
  const response = await httpClient.get(`/plans/${companyId}`);
  return response.data;
};

export const getPlanMemberSettings = async (priceId) => {
  const response = await httpClient.get('/plans/member-settings', {
    params: { price_id: priceId },
  });
  return response.data;
};

export const getPlan = async (planId) => {
  const response = await httpClient.get(`/plans/show/${planId}`);
  return response.data;
};

export const updatePlan = async (planId, data) => {
  const response = await httpClient.put(`/plans/${planId}`, data);
  return response.data;
};

// プラン別利用規約取得
export const getPlanTerms = async (planId) => {
  const response = await httpClient.get(`/plans/${planId}/terms`);
  return response.data;
};

/**
 * プラン別利用規約を更新 (admin only)
 * 規約内容が変更されている場合は新規規約が作成され、該当プランとの紐付けが更新される。
 * @param {number} planId - プランID
 * @param {object} termsData - { general_content, coupon_content, general_title?, coupon_title? }
 */
export const updatePlanTerms = async (planId, termsData) => {
  const response = await httpClient.put(`/plans/${planId}/terms`, termsData);
  return response.data;
};
